
export default function WhyUs() {
  const pillars = [
    {
      icon: 'ri-links-line',
      title: 'Asia-Based, International Reach',
      description: 'Deep relationships across Hong Kong, mainland China, Southeast Asia and global commodity networks.'
    },
    {
      icon: 'ri-search-line',
      title: 'Independent Research',
      description: 'Objective analysis and market intelligence free from conflicts of interest'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Execution-Focused',
      description: 'Practical advisory centered on implementation and measurable outcomes'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-8">
        {/* Header */}
        <h2 className="text-4xl lg:text-[44px] font-bold text-[#111111] text-center mb-14">
          Why Precious Leader Trade
        </h2>

        {/* Three Pillars */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {pillars.map((pillar, index) => (
            <div key={index} className="text-center p-10">
              <div className="w-9 h-9 mx-auto flex items-center justify-center">
                <i className={`${pillar.icon} text-[36px] text-[#B11226]`}></i>
              </div>
              <h3 className="mt-5 text-[22px] font-semibold text-[#111111]">
                {pillar.title}
              </h3>
              <p className="mt-3 text-[15px] text-[#666666] leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}